import React from "react";
import PropTypes from "prop-types";

class QAListItem extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="QA-list-item-container">
        <div className="QA-list-item-container-question">
          <img alt="" src={require("@/assets/images/lp_ic_q.svg")} />
          <div>{data.question}</div>
        </div>
        <div className="QA-list-item-container-answer">
          <img alt="" src={require("@/assets/images/lp_ic_a.svg")} />
          <div
            dangerouslySetInnerHTML={{
              __html: data.answer,
            }}
          />
        </div>
      </div>
    );
  }
}

QAListItem.propTypes = {
  data: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,
};

export default QAListItem;
